import React from "react";
import OnboardTerminalGrid from "./Grid";
import OnboardTerminalMap from "./Map";
import { withStyles } from "@material-ui/core";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { withTerminalsHOC } from "../../common/withTerminalsHOC";
import OnBoardTerminalForm from "./Form";

const styles = {
  onboardTerminalSubModule: {
    height: "100%",
    display: "flex",
    "&>div": {
      width: "50%",
      boxSizing: "border-box",
    },
    "&>.OnBoardTerminalForm": {
      width: "20%",
    },
  },
};

class TerminalOnboarding extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTerminals: [],
      isTerminalFormOpen: false,
      terminalInfo: null,
      terminalPosition: null,
      terminalGeoFencing: null,
    };
  }

  terminalSelectedOnGrid = (terminal) => {
    this.setState({
      selectedTerminals: terminal,
    });
  };

  terminalClickedOnMap = (terminal) => {
    if (!this.state.isTerminalFormOpen) {
      this.setState({
        selectedTerminals: terminal ? [terminal.data] : [],
      });
    }
  };

  onBoardTerminalFormClose = () => {
    this.setState({
      isTerminalFormOpen: false,
      terminalInfo: null,
      terminalPosition: null,
      terminalGeoFencing: null,
    });
  };

  onBoardTerminalFormOpen = (selectedTerminals, terminalInfo) => {
    this.setState({
      terminalGeoFencing: terminalInfo?.geoFence || null,
      isTerminalFormOpen: true,
      terminalPosition: null,
      terminalInfo,
      selectedTerminals,
    });
  };

  terminalPositionChange = (terminalPosition) => {
    if (
      terminalPosition?.latitude !== this.state.terminalPosition?.latitude &&
      terminalPosition?.longitude !== this.state.terminalPosition?.longitude
    ) {
      this.setState({
        terminalPosition: terminalPosition,
      });
    }
  };
  terminalGeoFencingChange = (terminalGeoFencing) => {
    if (terminalGeoFencing !== this.state.terminalGeoFencing) {
      this.setState({
        terminalGeoFencing: terminalGeoFencing,
      });
    }
  };

  render() {
    const {
      classes,
      getTerminalData,
      userData,
      terminalList,
      terminalDataMessage,
    } = this.props;
    const {
      selectedTerminals,
      isTerminalFormOpen,
      terminalInfo,
      terminalPosition,
      terminalGeoFencing,
    } = this.state;
    const selectedTerminalIds = selectedTerminals?.map(
      (terminal) => terminal.terminalId
    );
    return (
      <div className={classes.onboardTerminalSubModule}>
        <OnboardTerminalGrid
          data={terminalList || []}
          error={terminalDataMessage}
          selectedTerminals={selectedTerminals}
          selectedTerminalIds={selectedTerminalIds}
          isTerminalFormOpen={isTerminalFormOpen}
          terminalSelectedOnGrid={this.terminalSelectedOnGrid}
          onBoardTerminalFormOpen={this.onBoardTerminalFormOpen}
        />
        <OnboardTerminalMap
          data={terminalList || []}
          selectedTerminalIds={selectedTerminalIds}
          userData={userData}
          terminalInfo={terminalInfo}
          terminalClickedOnMap={this.terminalClickedOnMap}
          isTerminalFormOpen={isTerminalFormOpen}
          terminalPositionChange={this.terminalPositionChange}
          terminalPosition={terminalPosition}
          terminalGeoFencing={terminalGeoFencing}
        />

        {isTerminalFormOpen ? (
          <OnBoardTerminalForm
            terminalInfo={terminalInfo}
            onClose={this.onBoardTerminalFormClose}
            terminalPositionChange={this.terminalPositionChange}
            terminalPosition={terminalPosition}
            terminalList={terminalList || []}
            getTerminalData={getTerminalData}
            terminalGeoFencingChange={this.terminalGeoFencingChange}
          />
        ) : null}
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile
)(withTerminalsHOC(TerminalOnboarding));
